import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';


export function largerValidator(larger:number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    return control.value < larger ? {'appNotSmaller': {value: control.value}} : null;
  };
}

@Directive({
  selector: '[appNotSmaller]',
  providers: [{provide: NG_VALIDATORS, useExisting: LargerDirective, multi: true}]
})
export class LargerDirective implements Validator{
  @Input('appNotSmaller') larger: number;
 
  validate(control: AbstractControl): {[key: string]: any} {
    return this.larger ? largerValidator(this.larger)(control)
                              : null;
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
  private _onChange: () => void;

  ngOnChanges(changes: SimpleChanges): void {
 
    if ('larger' in changes) {
      
      if (this._onChange) this._onChange();
    }
  }

  

}
